module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAYAAADzoH0MAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAAGAAAAAAn7RgJAAAAu0lEQVQ4EWNgGAW0DYGM/z7RIIzPFhZ8kv8ZGEqh8ktxqWPCJUGs+KgBDAyDMAzS/huzFv4P5USPRpAYSA5dHMMLjAxSGd8ZfhzM+O8mBlMMYoPEQHIwMRiNYQADw3+QLab/Gdi2MzIwcoMwiA0Sg8rB9IJpRhQelJP23ycbKDEZqBks/5/h/39gss6dxbhlKrp6LC5gYIAoZCxDKGYsw6YZIY+Dlf7fZzUI45AGC+PNjb8ZmJLwaR4mcgBQ5TDqOpIeOgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/font_green.png
// module id = +ghU
// module chunks = 1